import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class SmsTemplate extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            isGlobal: props.IsGlobal,
            caller: props.Caller,
            data: null,
            loading: true,
            teams: []
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("api/v1/smstemplates/get", {
            id: this.getCurrentFormId(),
            isGlobal: this.state.isGlobal
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });

        var p2 = this.httpPost("api/v1/common/getcrmteams", { term: ''})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        teams: data.records,
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });

        Promise.all([p1, p2])
            .then(data => {
                this.setState({
                    loading: false
                });
            });
    }
    save(e) {
        if (this.isBlank(this.state.data.record.order)) this.state.data.record.order = 0;
        this.state.data.record.order = parseInt(this.state.data.record.order);

        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/smstemplates/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            code: this.state.data.record.code,
            order: this.state.data.record.order,
            status: this.state.data.record.status,
            content: this.state.data.record.content,
            rejectNote: this.state.data.record.rejectNote,
            useIn: this.state.data.record.useIn,
            crmTeams: this.state.data.record.crmTeams,
            isGlobal: this.state.isGlobal
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setStatus(e) {
        this.state.data.record.status = e;
        this.setState({ data: this.state.data });
    }
    useIn(e) {
        return this.state.data.record.useIn.includes('[' + e + ']');
    }
    setUseIn(k, e) {
        if (k == 'all' && e) {
            this.state.data.record.useIn = '[all]';
        }
        else {
            var useIn = this.state.data.record.useIn.replace('[' + k + ']', '');
            if (e)
                useIn += '[' + k + ']';
            this.state.data.record.useIn = useIn;
        }
        this.setState({ data: this.state.data });
    }
    crmTeams(e) {
        return this.state.data.record.crmTeams.includes('[' + e + ']');
    }
    setCrmTeams(k, e) {
        if (k == 'all' && e) {
            this.state.data.record.crmTeams = '[all]';
        }
        else {
            var crmTeams = this.state.data.record.crmTeams.replace('[' + k + ']', '');
            if (e)
                crmTeams += '[' + k + ']';
            this.state.data.record.crmTeams = crmTeams;
        }
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش الگوی پیامکی" : "افزودن الگوی پیامکی جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-8 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    {this.state.isGlobal && <div className="col-sm-2 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">کدالگو</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="20" />
                                        </div>
                                    </div>}
                                    <div className="col-sm-2 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">اولویت نمایش</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.order} onChange={e => this.state.data.record.order = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="20" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">متن پیام</label><span className="red">*</span>
                                            <textarea defaultValue={this.state.data.record.content} onChange={e => this.state.data.record.content = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="400"></textarea>
                                            <p>شما میتوانید از متغییرهای زیر در داخل متن پیام هایتان استفاده نمایید</p>
                                            <p>متغییر درج نام شخص: #name#</p>
                                        </div>
                                    </div>
                                    {this.state.isGlobal && <div className="col-sm-2 mb-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">وضعیت</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.status} onChange={e => this.setStatus(parseInt(e.target.value))} className="form-control input-sm">
                                                <option value="1">در انتظار بررسی</option>
                                                <option value="2">تایید شده</option>
                                                <option value="3">رد شده</option>
                                            </select>
                                        </div>
                                    </div>}
                                    {this.state.data.record.status === 3 && this.state.isGlobal &&
                                        <div className="col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label for="name" className="title1">علت رد شدن درخواست</label><span className="red">*</span>
                                                <input defaultValue={this.state.data.record.rejectNote} onChange={e => this.state.data.record.rejectNote = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="400" />
                                            </div>
                                        </div>
                                    }
                                    {this.state.data.record.status === 3 && !this.state.isGlobal &&
                                        <div className="col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label for="name" className="title1">علت رد شدن درخواست</label><span className="red">*</span>
                                                <p>{this.state.data.record.rejectNote}</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                                {!this.state.isGlobal &&
                                    <fieldset style={{"background-color": "aliceblue","padding": "0 15px"}}>
                                        <div className="row" key={this.state.data.record.useIn}>
                                            <legend style={{
                                                "border-bottom": "solid 1px white", "font-size": "16px", "font-weight": "bold"}}>سطوح استفاده از این الگو</legend>
                                        <div className="col-sm-12 mb-2">
                                            <div className="form-group">
                                                <input className="ml-2" defaultChecked={this.useIn('all')} onChange={e => this.setUseIn('all', e.target.checked)} type="checkbox" />
                                                تمامی زیر سیستم ها
                                            </div>
                                        </div>
                                        {<div className="col-sm-3 mb-2">
                                            <div className="form-group">
                                                <input className="ml-2" disabled={this.useIn('all')} defaultChecked={this.useIn('crm')} onChange={e => this.setUseIn('crm', e.target.checked)} type="checkbox" />
                                                مدیریت ارتباط با مشتریان
                                            </div>
                                        </div>}
                                        {<div className="col-sm-3 mb-2">
                                            <div className="form-group">
                                                <input className="ml-2" disabled={this.useIn('all')} defaultChecked={this.useIn('persons')} onChange={e => this.setUseIn('persons', e.target.checked)} type="checkbox" />
                                                مدیریت اشخاص و شرکتها
                                            </div>
                                        </div>}
                                        {<div className="col-sm-3 mb-2">
                                            <div className="form-group">
                                                    <input className="ml-2" disabled={this.useIn('all')} defaultChecked={this.useIn('building')} onChange={e => this.setUseIn('building', e.target.checked)} type="checkbox" />
                                                مدیریت ساختمان
                                            </div>
                                            </div>}
                                            {<div className="col-sm-3 mb-2">
                                                <div className="form-group">
                                                    <input className="ml-2" disabled={this.useIn('all')} defaultChecked={this.useIn('meeting')} onChange={e => this.setUseIn('meeting', e.target.checked)} type="checkbox" />
                                                    مدیریت جلسات
                                                </div>
                                            </div>}
                                    </div>
                                    </fieldset>}

                                {!this.state.isGlobal &&
                                    <fieldset style={{ "background-color": "aliceblue", "padding": "0 15px" }}>
                                        <div className="row" key={this.state.data.record.crmTeams}>
                                            <legend style={{
                                                "border-bottom": "solid 1px white", "font-size": "16px", "font-weight": "bold"
                                            }}>تیم های پیگیری مجاز به استفاده از این الگو</legend>
                                            <div className="col-lg-12 mb-2">
                                                <input className="ml-2" defaultChecked={this.crmTeams('all')} onChange={e => this.setCrmTeams('all', e.target.checked)} type="checkbox" />
                                                تمامی تیم ها
                                            </div>
                                            {this.state.teams.map(team =>
                                                <div className="col-sm-12 mb-2">
                                                    <div className="form-group">
                                                        <input className="ml-2" disabled={this.crmTeams('all')} defaultChecked={this.crmTeams(team.value)} onChange={e => this.setCrmTeams(team.value, e.target.checked)} type="checkbox" />
                                                        {team.label}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </fieldset>}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}